<template>
  <!--begin::Dashboard-->
  <div class="p-5 container">
    <div class="row mb-5" style="padding: 2vh;">
      <div class="col-12 col-lg-7">
        <p class="text-title-content" style="font-weight: 700;color: #333333;">
          {{ listData ? listData.title : "" }}
        </p>
        <div
          class="mb-3"
          v-if="listData && listData.hashtag"
          style="display: flex;flex-direction: row;
                    flex-wrap: nowrap;
                    overflow-x: hidden;"
        >
          <div
            style="margin-right:5px"
            v-for="(itemHas, index) in listData.hashtag"
            :key="index"
          >
            <router-link
              :to="'/course/voluntary?hashtag=' + itemHas"
              class="badge badge-danger"
              >{{ itemHas }}</router-link
            >
          </div>
        </div>
        <p class="text-category" style="font-weight: 700;color: #333333;">
          รายละเอียด
        </p>
        <p
          class="text-category"
          v-html="listData ? listData.description : ''"
          style="font-weight: 400;
                color: #7F7F81;"
        ></p>
        <p class="text-category" style="font-weight: 700;color: #333333;">
          กลุ่มเป้าหมาย
        </p>
        <p
          class="text-category"
          style="font-weight: 400;
                color: #7F7F81;"
        >{{listData && listData.expected?  listData.expected: '-'}}</p>
        <p class="text-category" style="font-weight: 700;color: #333333;">
          วัตถุประสงค์
        </p>
        <p
          class="text-category"
          v-html="listData ? listData.objective : ''"
          style="font-weight: 400;
                color: #7F7F81;"
        ></p>
        <!-- <p>{{ formatDate(listData ? listData.createDate : "") }}</p> -->
      </div>
      <div class="col-12 col-lg-5">
        <img
          v-if="listData"
          :src="listData ? imageUrl + listData.thumbnailsPath : ''"
          alt=""
          class="w-100 mb-3"
          style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            object-fit: cover;
            border-radius: 20px;
            border: 1px solid #dbdbdb;"
        />
        <div class="mb-3" style="display: flex;justify-content: space-between;">
          <div>
            <!-- <div v-if="listData && listData.rate"> -->
            <Rating
              :value="listData && listData.rate ? listData.rate : 0"
              :max="5"
            />
            <!-- </div> -->
          </div>
          <div style="display: flex;">
            <p class="my-auto">แชร์ไปยัง :</p>
            <img
              @click="share('facebook')"
              src="media/icon-app/facebook.svg"
              class="mx-1"
              alt=""
            />
            <img
              @click="share('line')"
              src="media/icon-app/line.svg"
              class="mx-1"
              alt=""
            />
            <img
              @click="share('twitter')"
              src="media/icon-app/twitter.svg"
              class="mx-1 w-30px"
              alt=""
            />
          </div>
        </div>
        <div
          class="d-flex align-items-center flex-column mt-3 w-100 mb-3"
          v-if="listData && listData.register == true"
        >
          <div
            class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
          >
            <span class="text-category"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_1174_14793)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 0H1V15H16V16H0V0ZM10 3.5C10 3.36739 10.0527 3.24021 10.1464 3.14645C10.2402 3.05268 10.3674 3 10.5 3H14.5C14.6326 3 14.7598 3.05268 14.8536 3.14645C14.9473 3.24021 15 3.36739 15 3.5V7.5C15 7.63261 14.9473 7.75979 14.8536 7.85355C14.7598 7.94732 14.6326 8 14.5 8C14.3674 8 14.2402 7.94732 14.1464 7.85355C14.0527 7.75979 14 7.63261 14 7.5V4.9L10.387 9.317C10.3428 9.37099 10.2877 9.41511 10.2254 9.44655C10.1631 9.47798 10.0949 9.49602 10.0252 9.4995C9.9555 9.50299 9.88584 9.49184 9.8207 9.46678C9.75556 9.44172 9.69639 9.4033 9.647 9.354L7.06 6.767L3.404 11.794C3.32402 11.8957 3.20774 11.9624 3.07958 11.9802C2.95143 11.9979 2.82138 11.9653 2.71677 11.8892C2.61216 11.8131 2.54113 11.6994 2.51861 11.572C2.49609 11.4446 2.52383 11.3134 2.596 11.206L6.596 5.706C6.63846 5.64751 6.69309 5.59893 6.75613 5.56359C6.81917 5.52825 6.88912 5.50699 6.96117 5.50129C7.03322 5.49559 7.10564 5.50557 7.17346 5.53055C7.24128 5.55554 7.30287 5.59492 7.354 5.646L9.963 8.256L13.445 4H10.5C10.3674 4 10.2402 3.94732 10.1464 3.85355C10.0527 3.75979 10 3.63261 10 3.5Z"
                    fill="#323563"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1174_14793">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              ความก้าวหน้า</span
            >
            <span>{{ listData ? listData.progressUpdate : "0" }}%</span>
          </div>
          <div
            class="mx-3 w-100 "
            style="background:#E1F2FF;height:25px;border-radius: 100px;"
          >
            <div
              class="bg-progressbar "
              style="height:25px;border-radius: 100px;"
              data-bs-toggle="tooltip"
              :title="listData.progressUpdate + '%'"
              role="progressbar"
              :style="
                'width: ' + (listData ? listData.progressUpdate : '') + '%'
              "
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <div class="mb-3 row">
          <div class="col">
            <p
              class="text-category"
              style="font-weight: 700;
                    color: #323563;"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M11.9077 8.99173L9.16602 11.7417L8.09102 10.6584C7.9341 10.5015 7.72127 10.4133 7.49935 10.4133C7.27743 10.4133 7.0646 10.5015 6.90768 10.6584C6.75076 10.8153 6.66261 11.0281 6.66261 11.2501C6.66261 11.472 6.75076 11.6848 6.90768 11.8417L8.57435 13.5084C8.65182 13.5865 8.74399 13.6485 8.84554 13.6908C8.94708 13.7331 9.05601 13.7549 9.16602 13.7549C9.27603 13.7549 9.38495 13.7331 9.4865 13.6908C9.58805 13.6485 9.68021 13.5865 9.75768 13.5084L13.091 10.1751C13.2479 10.0181 13.3361 9.80531 13.3361 9.58339C13.3361 9.36147 13.2479 9.14865 13.091 8.99173C12.9341 8.83481 12.7213 8.74665 12.4993 8.74665C12.2774 8.74665 12.0646 8.83481 11.9077 8.99173V8.99173ZM15.8327 4.58339H10.5993L10.3327 3.75006C10.1598 3.26108 9.83914 2.83798 9.4151 2.53936C8.99106 2.24074 8.48465 2.08139 7.96602 2.08339H4.16602C3.50297 2.08339 2.86709 2.34678 2.39825 2.81563C1.92941 3.28447 1.66602 3.92035 1.66602 4.58339V15.4167C1.66602 16.0798 1.92941 16.7157 2.39825 17.1845C2.86709 17.6533 3.50297 17.9167 4.16602 17.9167H15.8327C16.4957 17.9167 17.1316 17.6533 17.6005 17.1845C18.0693 16.7157 18.3327 16.0798 18.3327 15.4167V7.08339C18.3327 6.42035 18.0693 5.78447 17.6005 5.31563C17.1316 4.84679 16.4957 4.58339 15.8327 4.58339ZM16.666 15.4167C16.666 15.6377 16.5782 15.8497 16.4219 16.006C16.2657 16.1623 16.0537 16.2501 15.8327 16.2501H4.16602C3.945 16.2501 3.73304 16.1623 3.57676 16.006C3.42048 15.8497 3.33268 15.6377 3.33268 15.4167V4.58339C3.33268 4.36238 3.42048 4.15042 3.57676 3.99414C3.73304 3.83786 3.945 3.75006 4.16602 3.75006H7.96602C8.14072 3.74961 8.31115 3.80408 8.45321 3.90576C8.59527 4.00745 8.70178 4.15121 8.75768 4.31673L9.20768 5.68339C9.26359 5.84891 9.3701 5.99267 9.51216 6.09436C9.65422 6.19604 9.82465 6.25051 9.99935 6.25006H15.8327C16.0537 6.25006 16.2657 6.33786 16.4219 6.49414C16.5782 6.65042 16.666 6.86238 16.666 7.08339V15.4167Z"
                  fill="#323563"
                />
              </svg>
              หมวดหมู่
            </p>
            <p class="text-category" style="margin-left:1.5vw;color:#464646">
              {{ listData && listData.categoryProfile.length>0 ? listData.categoryProfile[0][0].data : "" }}
            </p>
          </div>
          <div class="col">
            <p
              class="text-category"
              style="font-weight: 700;
                    color: #323563;"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.50065 8.33329H8.33398C8.555 8.33329 8.76696 8.2455 8.92324 8.08922C9.07952 7.93293 9.16732 7.72097 9.16732 7.49996C9.16732 7.27895 9.07952 7.06698 8.92324 6.9107C8.76696 6.75442 8.555 6.66663 8.33398 6.66663H7.50065C7.27964 6.66663 7.06768 6.75442 6.9114 6.9107C6.75512 7.06698 6.66732 7.27895 6.66732 7.49996C6.66732 7.72097 6.75512 7.93293 6.9114 8.08922C7.06768 8.2455 7.27964 8.33329 7.50065 8.33329V8.33329ZM7.50065 9.99996C7.27964 9.99996 7.06768 10.0878 6.9114 10.244C6.75512 10.4003 6.66732 10.6123 6.66732 10.8333C6.66732 11.0543 6.75512 11.2663 6.9114 11.4225C7.06768 11.5788 7.27964 11.6666 7.50065 11.6666H12.5007C12.7217 11.6666 12.9336 11.5788 13.0899 11.4225C13.2462 11.2663 13.334 11.0543 13.334 10.8333C13.334 10.6123 13.2462 10.4003 13.0899 10.244C12.9336 10.0878 12.7217 9.99996 12.5007 9.99996H7.50065ZM16.6673 7.44996C16.6586 7.3734 16.6419 7.29799 16.6173 7.22496V7.14996C16.5773 7.06428 16.5238 6.98551 16.459 6.91663V6.91663L11.459 1.91663C11.3901 1.85181 11.3113 1.79836 11.2257 1.75829C11.2008 1.75476 11.1755 1.75476 11.1507 1.75829C11.066 1.70974 10.9725 1.67858 10.8757 1.66663H5.83398C5.17094 1.66663 4.53506 1.93002 4.06622 2.39886C3.59738 2.8677 3.33398 3.50358 3.33398 4.16663V15.8333C3.33398 16.4963 3.59738 17.1322 4.06622 17.6011C4.53506 18.0699 5.17094 18.3333 5.83398 18.3333H14.1673C14.8304 18.3333 15.4662 18.0699 15.9351 17.6011C16.4039 17.1322 16.6673 16.4963 16.6673 15.8333V7.49996C16.6673 7.49996 16.6673 7.49996 16.6673 7.44996ZM11.6673 4.50829L13.8257 6.66663H12.5007C12.2796 6.66663 12.0677 6.57883 11.9114 6.42255C11.7551 6.26627 11.6673 6.05431 11.6673 5.83329V4.50829ZM15.0007 15.8333C15.0007 16.0543 14.9129 16.2663 14.7566 16.4225C14.6003 16.5788 14.3883 16.6666 14.1673 16.6666H5.83398C5.61297 16.6666 5.40101 16.5788 5.24473 16.4225C5.08845 16.2663 5.00065 16.0543 5.00065 15.8333V4.16663C5.00065 3.94561 5.08845 3.73365 5.24473 3.57737C5.40101 3.42109 5.61297 3.33329 5.83398 3.33329H10.0007V5.83329C10.0007 6.49633 10.264 7.13222 10.7329 7.60106C11.2017 8.0699 11.8376 8.33329 12.5007 8.33329H15.0007V15.8333ZM12.5007 13.3333H7.50065C7.27964 13.3333 7.06768 13.4211 6.9114 13.5774C6.75512 13.7337 6.66732 13.9456 6.66732 14.1666C6.66732 14.3876 6.75512 14.5996 6.9114 14.7559C7.06768 14.9122 7.27964 15 7.50065 15H12.5007C12.7217 15 12.9336 14.9122 13.0899 14.7559C13.2462 14.5996 13.334 14.3876 13.334 14.1666C13.334 13.9456 13.2462 13.7337 13.0899 13.5774C12.9336 13.4211 12.7217 13.3333 12.5007 13.3333Z"
                  fill="#323563"
                />
              </svg>
              รหัสวิชา
            </p>
            <p class="text-category" style="margin-left:1.5vw;color:#545454">
              {{ listData && listData.courseCode ? listData.courseCode : "-" }}
            </p>
          </div>
        </div>
        <div class="mb-3 row">
          <div class="col">
            <p
              class="text-category"
              style="font-weight: 700;
                    color: #323563;"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="21"
                viewBox="0 0 18 21"
                fill="none"
              >
                <ellipse
                  cx="8.68509"
                  cy="8.58352"
                  rx="3.58352"
                  ry="3.58352"
                  stroke="#323563"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 17.151C2.99905 16.8991 3.05539 16.6503 3.16477 16.4234C3.50802 15.7369 4.47598 15.373 5.27919 15.2083C5.85846 15.0846 6.44573 15.0021 7.03663 14.9611C8.13063 14.865 9.23095 14.865 10.325 14.9611C10.9158 15.0025 11.503 15.0851 12.0824 15.2083C12.8856 15.373 13.8536 15.7025 14.1968 16.4234C14.4168 16.886 14.4168 17.423 14.1968 17.8856C13.8536 18.6064 12.8856 18.9359 12.0824 19.0938C11.5038 19.2226 10.9163 19.3075 10.325 19.3478C9.43453 19.4233 8.53994 19.4371 7.64761 19.389C7.44166 19.389 7.24258 19.389 7.03663 19.3478C6.44747 19.308 5.86224 19.2231 5.28605 19.0938C4.47598 18.9359 3.51489 18.6064 3.16477 17.8856C3.05595 17.656 2.99966 17.4051 3.00001 17.151Z"
                  stroke="#323563"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              อาจารย์ผู้สอน
            </p>
            <p  class="text-category" style="margin-left:1.5vw;color:#464646">
           {{ instructor }}
            </p>
          </div>
          <div class="col">
            <p
              class="text-category"
              style="font-weight: 700;
                    color: #323563;"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
              >
                <g clip-path="url(#clip0_1174_14777)">
                  <path
                    d="M7.5 9L10.5 5.25H8.25V0H6.75V5.25H4.5L7.5 9Z"
                    fill="#323563"
                  />
                  <path
                    d="M13.5 10.5H1.5V5.25H0V10.5C0 11.3273 0.67275 12 1.5 12H13.5C14.3273 12 15 11.3273 15 10.5V5.25H13.5V10.5Z"
                    fill="#323563"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1174_14777">
                    <rect width="15" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              ระยะเวลา (นาที)
            </p>
            <p class="text-category" style="margin-left:1.5vw;color:#464646">
              {{ listData && listData.duration ? listData.duration : "-" }}
            </p>
          </div>
        </div>
        <div>
          <button
            v-if="listData && listData.register == false"
            type="button"
            @click="register()"
            class="btn btn-register2 w-100"
            style="border-radius: 21px;"
          >
            ลงทะเบียน
          </button>
          <button
            v-else-if="listData && listData.register == true && listData.statusRegister == 5"
            type="button"
            @click="register()"
            class="btn btn-register2 w-100"
            style="border-radius: 21px;"
          >
            ลงทะเบียนใหม่อีกครั้ง(หมดเวลาเรียน)
          </button>
          <!-- <button
            v-else-if="listData && listData.progressUpdate == 100"
            type="button"
            @click="register()"
            class="btn btn-success w-100"
            style="border-radius: 21px;"
          >
            จบบทเรียน
          </button> -->
          <button
            v-else
            type="button"
            @click="register()"
            class="btn btn-learn w-100"
          >
            เข้าสู่บทเรียน
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
/* eslint-disable */
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Rating from "../Rating.vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
const listData = ref();

const instructor = ref('')
const courseRegister = ref();
export default defineComponent({
  name: "voluntary-detail",
  components: {
    Rating,
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    onMounted(async () => {
      const courseRegisterResponse = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          route.params.id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: {
            token: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : localStorage.getItem("tokenGuest"),
          },
        }
      );
      courseRegister.value = courseRegisterResponse.data.data.content[0];
      getDataList();
    });
    const getDataList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourse?id=" +
            route.params.id +
            "&os=0",
          // "&categories=" +
          // categories.value
          {
            headers: {
              token: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then((response) => {
          // console.log(response);
          listData.value = response.data.data.content[0];
          // console.log(listData.value);
          renderInstructor(listData.value.instructor)
          setCurrentPageBreadcrumbs(listData.value.title, ["หลักสูตรทั่วไป"]);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const renderInstructor = (uid) =>{
      // console.log("renderInstructor");
      if (uid) {
        axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getProfile?id=" + uid ,
          {
            headers: { token: localStorage.getItem("id_token")},
           
          }
        )
        .then((response) => {
          instructor.value = response.data.data.firstName + " " +  response.data.data.lastName
        })
        .catch((error) => {
        });
      }else{
        instructor.value = "-"
      }
    
    }
    const register = async () => {
      if (localStorage.getItem("id_token")) {
        if (listData.value.register == false || (listData.value.register == true && listData.value.statusRegister == 5)) {
          if (listData.value.register == true && listData.value.statusRegister == 5) {
            await axios
          .delete(process.env.VUE_APP_API_URL + "/deleteCourseRegister?id=" + courseRegister.value.id,{
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          })
          }
          let formData = new FormData();
          formData.append("courseId", route.params.id + "");
          axios
            .post(process.env.VUE_APP_API_URL + "/registerCourse", formData, {
              headers: {
                token: localStorage.getItem("id_token")
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                Swal.fire({
                  title: "ลงทะเบียนสำเร็จ",
                  text: "รายการของคุณลงทะเบียนเรียบร้อยแล้ว",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "ตกลง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-primary",
                  },
                }).then(function(res) {
                  router.push({
                    name: "voluntary-learn",
                    params: { id: route.params.id },
                  });
                });
              } else {
                  Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: res.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
              }
            })
            .catch((error) => {
              // console.log(error);
            });
        } else {
        
            router.push({
            name: "voluntary-learn",
            params: { id: route.params.id },
          });
         
        
        }
      } else {
        router.push({ name: "sign-in" });
      }
    };
    const share = (social) => {
      const url = new URL(window.location.href);
      if (social == "facebook") {
        window.open(
          "http://facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
        );
      } else if (social == "twitter") {
        window.open(
          "http://www.twitter.com/share?url=" + encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
        );
      } else {
        window.open(
          "https://social-plugins.line.me/lineit/share?url=" +
            encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
        );
      }
    };
    return {
      getDataList,
      listData,
      register,
      share,
      renderInstructor,
      instructor,
      courseRegister
    };
  },
  methods: {
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    rederRecommend(data) {
      // const dataMock = [
      //   "สำหรับประชาชนทั่วไป",
      //   "นักเรียนนักศึกษา",
      //   "คณะทำงานด้านเทคนิค",
      //   "เจ้าหน้าที่ปกครองส่วนท้องถิ่นวิศวกร",
      //   "ผู้พัฒนาโครงการ",
      // ];
      if (data.length > 0) {
        return data.join(", ");
      } else {
        return "-";
      }
    },
   
  },
});
</script>
